<script setup lang="ts">
import BaseIframeModal from "@/components/BaseIframeModal.vue";
import type { Organisation } from "@/types";

const { organisation } = defineProps<{
  organisation: Organisation;
}>();
</script>

<template>
  <BaseIframeModal
    size="xl"
    min-height="500px"
    fullscreen="lg-down"
    is-centered
    :title="organisation.name"
    :src="`/organisations/${organisation.id}`"
  />
</template>
